/* ---------------------------------------------------------------------------
   "לזכור את המכשיר ל-30 יום" — טוקן אקראי מהשרת, אחד לכל משתמש בדפדפן הזה.

   ב-localStorage בכוונה (בניגוד לטוקן הגישה): הוא צריך לשרוד סגירת טאב.
   הוא לא נותן גישה לבדו — רק מדלג על הקוד *אחרי* סיסמה נכונה. בשרת נשמר רק
   ה-hash שלו, קשור למשתמש, ומבוטל בכיבוי 2FA ובהחלפת סיסמה.
   --------------------------------------------------------------------------- */

const KEY = 'craftmind.mfaDevices';

type Store = { last?: string; byEmail: Record<string, string> };

function read(): Store {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? (JSON.parse(raw) as Partial<Store>) : {};
    return { last: parsed.last, byEmail: parsed.byEmail ?? {} };
  } catch {
    return { byEmail: {} };
  }
}

function write(s: Store): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(s));
  } catch {
    /* מצב פרטי — פשוט יבקשו קוד בפעם הבאה */
  }
}

const norm = (email: string) => email.trim().toLowerCase();

export const mfaDeviceStore = {
  get: (email: string): string | undefined => read().byEmail[norm(email)],
  /** כניסה עם Google: האימייל עוד לא ידוע — המשתמש האחרון שנזכר בדפדפן הזה. */
  getLast: (): string | undefined => {
    const s = read();
    return s.last ? s.byEmail[s.last] : undefined;
  },
  set: (email: string, token: string): void => {
    const s = read();
    s.byEmail[norm(email)] = token;
    s.last = norm(email);
    write(s);
  },
  clear: (email: string): void => {
    const s = read();
    delete s.byEmail[norm(email)];
    if (s.last === norm(email)) s.last = undefined;
    write(s);
  },
};
